import './ClubOneLoggedIn.scss'

import { ClubOneCardIcon } from '@tallink/components-lib'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getUser } from '../../../../../selectors/selectors'
import ClubOneHint from '../ClubOneHint/ClubOneHint'
import SwitchToCompany from './SwitchToCompany'

export default function ClubOneLoggedIn() {
  const { t } = useTranslation()
  const [width, setWidth] = useState(0)
  const { clubOneLevel, firstName, lastName, clubOnePoints } = useSelector(getUser)

  return (
    <section
      className="club-one-logged-in"
      ref={el => {
        if (!el) return

        setWidth(el.offsetWidth)
      }}
    >
      <div className="club-one-logged-in-header">
        <div className="title">{t('clubOne.level', { level: clubOneLevel })}</div>
        <div className="points">
          <div className="points-value">{clubOnePoints}</div>
          <div className="points-description">{t('clubOne.points.points')}</div>
          <ClubOneHint containerWidth={width} hintText={t('clubOne.points.hint')} />
        </div>
      </div>
      <div className="club-one-logged-in-main-content">
        <div className="icon-container">
          <ClubOneCardIcon level={clubOneLevel} />
        </div>
        <div className="text-container">
          <div className="name">
            {firstName} {lastName}
          </div>
          <SwitchToCompany containerWidth={width} />
        </div>
      </div>
    </section>
  )
}
